import React from 'react';
import clsx from 'clsx';

import scss from './BurgerIcon.module.scss';

function BurgerIcon({ onChange, isOpen }) {
  const toggleBurgerMenu = () => {
    if (onChange) {
      onChange(!isOpen);
    }
  };

  return (
    <div className={clsx(scss.burgerIcon, isOpen && scss.open)} onClick={toggleBurgerMenu} role='presentation'>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

export default BurgerIcon;
